<template>
  <div>
    <div class='text-center' v-if='loadReviews'>
      <i class='fa fa-spinner fa-pulse'></i>
    </div>
    <div v-if='!loadReviews'>
      <b-nav tabs fill v-if='reviewData.length > 0'>
        <b-nav-item v-bind:active="customerReviewsContentTabIndex == ReviewsNavTabs.Sales" v-on:click="switchSecondaryTab(ReviewsNavTabs.Sales)"
          title='Sales'>
          Sales
        </b-nav-item>
        <b-nav-item v-bind:active="customerReviewsContentTabIndex == ReviewsNavTabs.Service" v-on:click="switchSecondaryTab(ReviewsNavTabs.Service)"
          title='Service'>
          Service
        </b-nav-item>
        <b-nav-item v-bind:active="customerReviewsContentTabIndex == ReviewsNavTabs.All" v-on:click="switchSecondaryTab(ReviewsNavTabs.All)"
          title='All'>
          All
        </b-nav-item>
      </b-nav>
    </div>
    <div>
      <div id="" v-if="customerReviewsContentTabIndex == ReviewsNavTabs.Sales" class="content pt-3">
        <div>
          <ul class="list-group list-group-flush">
            <li class="list-group-item" v-for='(value,key,index) in salesReviews' :key='index'>
              <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
                  <p class="mb-3">
                    <img v-for='(n,index) in value.Stars' :key='index' height="18px" width="18px" src="static/assets/img/SVGIcons/icon-star-gold.svg"
                    />
                  </p>
                  <p class="mb-2">Employee:
                    <strong class="text-primary">{{value.Employee}}</strong>
                  </p>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
                  <h6>Sales</h6>
                  <p class="small">{{value.Date | formatDate('MM/DD/YYYY')}}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <p class="text-steel">“{{value.Comment}}”</p>
                </div>
              </div>
            </li>
          </ul>
          <div v-if='salesReviews.length == 0 && !loadReviews'>
            There are currently no Sales Reviews.
          </div>
        </div>
      </div>
      <div id="" v-if="customerReviewsContentTabIndex == ReviewsNavTabs.Service" class="content pt-3">
        <div>
          <ul class="list-group list-group-flush">
            <li class="list-group-item" v-for='(value,key,index) in serviceReviews' :key='index'>
              <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
                  <p class="mb-3">
                    <img v-for='(n,index) in value.Stars' :key='index' height="18px" width="18px" src="static/assets/img/SVGIcons/icon-star-gold.svg"
                    />
                  </p>
                  <p class="mb-2">Employee:
                    <strong class="text-primary">{{value.Employee}}</strong>
                  </p>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
                  <h6>Service</h6>
                  <p class="small">{{value.Date | formatDate('MM/DD/YYYY')}}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <p class="text-steel">“{{value.Comment}}”</p>
                </div>
              </div>
            </li>
          </ul>
          <div v-if='serviceReviews.length == 0 && !loadReviews'>
            There are currently no Service Reviews.
          </div>
        </div>
      </div>
      <div id="" v-if="customerReviewsContentTabIndex == ReviewsNavTabs.All" class="content pt-3">
        <div>
          <ul class="list-group list-group-flush">
            <li class="list-group-item" v-for='(value,key,index) in reviewData' :key='index'>
              <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
                  <p class="mb-3">
                    <img v-for='(n,index) in value.Stars' :key='index' height="18px" width="18px" src="static/assets/img/SVGIcons/icon-star-gold.svg"
                    />
                  </p>
                  <p class="mb-2">Employee:
                    <strong class="text-primary">{{value.Employee}}</strong>
                  </p>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
                  <h6>{{value.FeedbackTypeID}}</h6>
                  <p class="small">{{value.Date | formatDate('MM/DD/YYYY hh:mm a')}}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <p class="text-steel">“{{value.Comment}}”</p>
                </div>
              </div>
            </li>
          </ul>
          <div v-if='reviewData.length == 0 && !loadReviews'>
            There are currently no Reviews.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    CustomerAPIClient
  } from '@/lib/data_access/Customer'
  import moment from 'moment';
  export default {
    name: 'customerReviews',
    data() {
      return {
        customerReviewsContentTabIndex: 2,
        ReviewsNavTabs: {
          Sales: 0,
          Service: 1,
          All: 2
        },
        reviewData: [],
        loadReviews: true
      }
    },
    computed: {
      salesReviews: function () {
        let vm = this;
        if (vm.reviewData == null) {
          return []
        } else {
          return vm.reviewData.filter(function (element) {
            return element.FeedbackTypeID == 'Sales'
          })
        }
      },
      serviceReviews: function () {
        let vm = this;
        if (vm.reviewData == null) {
          return []
        } else {
          return vm.reviewData.filter(function (element) {
            return element.FeedbackTypeID == 'Service'
          })
        }
      }
    },
    methods: {
      switchSecondaryTab: function (secondaryTabIndex) {
        this.customerReviewsContentTabIndex = secondaryTabIndex;
      }
    },
    created() {
      let vm = this;
      vm.loadReviews = true
      let custIds = vm.$parent.assosciatedIds
      CustomerAPIClient.getCustomerReviews(custIds).then(function (reviewData) {
        vm.reviewData = reviewData;
        vm.loadReviews = false
      })
    },
    filters: {
      formatDate: function (value, momentFormat) {
        if (!value) return ''
        return moment(String(value)).format(momentFormat)
      }
    }
  }

</script>

<style lang='scss' scoped>
  /* Basic & Basic Justified Iconic Tabs */

  .nav.nav-tabs .nav-link {
    color: $blue-lt;
    font-weight: 400;
    transition: none;
  }

  .nav-tabs {
    border-bottom: 1px solid $gray-lt;
  }

  .nav-tabs .nav-link {
    border: none;
  }

  .nav-tabs .nav-link.active {
    border-bottom: 5px solid $blue-lt;
    color: $charcoal;
  } // Review Cards
  .rm-card-wrapper {
    padding: 5px;
  }

  .rm-card {
    width: 100%;
    min-width: 372px;
    border: 1px solid #e7e7e7;
    border-radius: 10px;
    display: inline-block;
    padding: 25px 10px 25px 10px;
  }

  .rm-card-positive {
    border-left: 10px solid #3faf49;
  }

  .rm-card-negative {
    border-left: 10px solid #ed2124;
  }

  .rm-card-dealsheet,
  .rm-card-employee,
  .rm-card-dealership,
  .rm-card-vin,
  .rm-card-gross {
    float: left;
    clear: both;
    margin-top: 5px;
  }

  .rm-card-left h3 {
    font-size: 16px;
    font-weight: 500;
    padding: 0;
    margin: 0;
  }





  /* Review Builder Cards */

  .card.reviewbuilder {
    box-shadow: 0 1px 10px 1px rgba(115, 108, 203, .1);
    border: 1px solid #e7e7e7;
    border-radius: $Border-radius;
  }

  .card.reviewbuilder .card-body div div>span {
    display: block;
  }

  .card.reviewbuilder.positive {
    border-left: 10px solid #3faf49;
  }

  .card.reviewbuilder.negative {
    border-left: 10px solid #ed2124;
  }

  .card.reviewbuilder.noresponse {
    border-left: 10px solid #000;
  }

  .card.reviewbuilder .reviewbuilder-card-rating,
  .card.reviewbuilder .reviewbuilder-card-department,
  .card.reviewbuilder .reviewbuilder-card-date,
  .card.reviewbuilder .reviewbuilder-card-site {
    text-align: right;
  }

  .card.reviewbuilder .reviewbuilder-card-title {
    font-weight: bold;
    font-size: 16px;
    color: #1f8bd5;
  }

  .card.reviewbuilder .reviewbuilder-card-dealsheet {
    font-size: 12px;
    margin-bottom: 15px;
  }

  .card.reviewbuilder .reviewbuilder-card-dealsheet img {
    height: 12px;
    width: auto;
    margin-right: 5px;
  }

  .card.reviewbuilder .reviewbuilder-card-rating {
    line-height: 2;
  }

  .card.reviewbuilder .reviewbuilder-card-rating img {
    height: 16px;
    width: auto;
  }

  .card.reviewbuilder .reviewbuilder-card-department {
    font-weight: 500;
    font-size: 16px;
  }

  .card.reviewbuilder .reviewbuilder-card-site {
    position: absolute;
    bottom: 0;
    right: 10px;
  }

  .card.reviewbuilder .reviewbuilder-card-site img {
    height: 30px;
    width: auto;
  }

</style>



// WEBPACK FOOTER //
// src/components/CustomerProfile/Reviews/CustomerReviews.vue